export enum LuckyDrawStatus {
  'Inactive' = 0,
  'Active',
  'Ended',
  'Completed',
}
